var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 10.0003C1.66602 6.07195 1.66602 4.10777 2.8864 2.88738C4.10679 1.66699 6.07098 1.66699 9.99935 1.66699C13.9277 1.66699 15.8919 1.66699 17.1123 2.88738C18.3327 4.10777 18.3327 6.07195 18.3327 10.0003C18.3327 13.9287 18.3327 15.8929 17.1123 17.1133C15.8919 18.3337 13.9277 18.3337 9.99935 18.3337C6.07098 18.3337 4.10679 18.3337 2.8864 17.1133C1.66602 15.8929 1.66602 13.9287 1.66602 10.0003Z",
    stroke: "#1D1616",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3327,
    cy: 6.66667,
    r: 1.66667,
    stroke: "#1D1616",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 10.4165L3.12567 9.13927C3.88506 8.47481 5.02958 8.51292 5.74309 9.22642L9.31786 12.8012C9.89055 13.3739 10.7921 13.452 11.4547 12.9863L11.7032 12.8116C12.6567 12.1415 13.9468 12.2192 14.8131 12.9988L17.4993 15.4165",
    stroke: "#1D1616",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/Gallery.67c391f0334f015a669d7b0093a54d4e.svg";
export { ForwardRef as ReactComponent };